/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;

  var format = function format(val) {
    if (val == "") {
      return "----";
    } else {
      return val;
    }
  };

  var check = function check() {
    var date = new Date($(".select_date").val());
    var toDate = new Date();

    if (date > toDate) {
      $f7.dialog.alert("Please select previous date");
      return false;
    }

    $f7.views.main.router.navigate("/kiosk_result/?select_date=" + $(".select_date").val(), {
      reloadCurrent: true
    });
  };

  var update4D6D = function update4D6D(data) {
    if (data == undefined) return;
    var obj = JSON.parse(data);
    $(".result_4d_A_num").html(format(obj["DrawNumberA"]));
    $(".result_4d_B_num").html(format(obj["DrawNumberB"]));
    $(".result_4d_C_num").html(format(obj["DrawNumberC"]));
    $(".result_4d_D_num").html(format(obj["DrawNumberD"]));
    $(".result_4d_E_num").html(format(obj["DrawNumberE"]));
    $(".result_4d_F_num").html(format(obj["DrawNumberF"]));
    $(".result_4d_G_num").html(format(obj["DrawNumberG"]));
    $(".result_4d_H_num").html(format(obj["DrawNumberH"]));
    $(".result_4d_I_num").html(format(obj["DrawNumberI"]));
    $(".result_4d_J_num").html(format(obj["DrawNumberJ"]));
    $(".result_4d_K_num").html(format(obj["DrawNumberK"]));
    $(".result_4d_L_num").html(format(obj["DrawNumberL"]));
    $(".result_4d_M_num").html(format(obj["DrawNumberM"]));
    $(".result_4d_N_num").html(format(obj["DrawNumberN"]));
    $(".result_4d_O_num").html(format(obj["DrawNumberO"]));
    $(".result_4d_P_num").html(format(obj["DrawNumberP"]));
    $(".result_4d_Q_num").html(format(obj["DrawNumberQ"]));
    $(".result_4d_R_num").html(format(obj["DrawNumberR"]));
    $(".result_4d_S_num").html(format(obj["DrawNumberS"]));
    $(".result_4d_T_num").html(format(obj["DrawNumberT"]));
    $(".result_4d_U_num").html(format(obj["DrawNumberU"]));
    $(".result_4d_V_num").html(format(obj["DrawNumberV"]));
    $(".result_4d_W_num").html(format(obj["DrawNumberW"]));
    $(".result_4d_1_alpha").html(obj["DrawNumber1"]);
    $(".result_4d_1_num").html(format(obj["DrawNumber" + obj["DrawNumber1"]]));
    $(".result_4d_" + obj["DrawNumber1"] + "_num").html("----");
    $(".result_4d_2_alpha").html(obj["DrawNumber2"]);
    $(".result_4d_2_num").html(format(obj["DrawNumber" + obj["DrawNumber2"]]));
    $(".result_4d_" + obj["DrawNumber2"] + "_num").html("----");
    $(".result_4d_3_alpha").html(obj["DrawNumber3"]);
    $(".result_4d_3_num").html(format(obj["DrawNumber" + obj["DrawNumber3"]]));
    $(".result_4d_" + obj["DrawNumber3"] + "_num").html("----");
    $(".Result_6d_1").html(obj.DrawNumber6D.charAt(0));
    $(".Result_6d_2").html(obj.DrawNumber6D.charAt(1));
    $(".Result_6d_3").html(obj.DrawNumber6D.charAt(2));
    $(".Result_6d_4").html(obj.DrawNumber6D.charAt(3));
    $(".Result_6d_5").html(obj.DrawNumber6D.charAt(4));
    $(".Result_6d_6").html(obj.DrawNumber6D.charAt(5));
    $(".result_4d_jackpot_pool").html(obj.JackpotPrize);
    $(".prize-grand").html(obj.JackpotNumber61D);
    $(".prize-consolation").html(obj.JackpotNumber61D.substring(1));
    $(".JackpotBonus").html(obj.JackpotBonus);
    $(".DrawNumberA").html(obj.DrawNumberA);
    $(".JackpotUnit").html(obj.JackpotUnit);
    $(".JackpotWinner").html(obj.JackpotWinner);
    $(".JackpotPayout").html(obj.JackpotPayout);
    $(".JackpotPrize").html(obj.JackpotPrize);
    $(".JackpotPercent").html(obj.JackpotPercent);
    $(".Jackpot61DPool").html(parseFloat(obj.Jackpot61DPool).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));
    $(".JackpotPayout6D1").html(obj.JackpotPayout6D1);
    $(".JackpotPrize").html("$" + obj.JackpotPrize.substring(3));
    $(".JackpotNumber61D").html(parseFloat(obj.JackpotNumber61D));
    $(".JackpotNumber61D_consolation").html(parseFloat("-" + obj.JackpotNumber61D.substring(1)));
    var d = obj.Jackpot61DDate.substring(10, 8);
    var m = parseInt(obj.Jackpot61DDate.substring(7, 5));
    var y = obj.Jackpot61DDate.substring(0, 4);
    var mTxt = "";
    if (m == 1) mTxt = "Jan";
    if (m == 2) mTxt = "Feb";
    if (m == 3) mTxt = "Mar";
    if (m == 4) mTxt = "Apr";
    if (m == 5) mTxt = "May";
    if (m == 6) mTxt = "Jun";
    if (m == 7) mTxt = "Jul";
    if (m == 8) mTxt = "Aug";
    if (m == 9) mTxt = "Sep";
    if (m == 10) mTxt = "Oct";
    if (m == 11) mTxt = "Nov";
    if (m == 12) mTxt = "Dec";
    $(".Jackpot61DDate").html(d + " " + mTxt + " " + y);
    $(".Result_6d_1").html(obj.DrawNumber6D.charAt(0));
    $(".Result_6d_2").html(obj.DrawNumber6D.charAt(1));
    $(".Result_6d_3").html(obj.DrawNumber6D.charAt(2));
    $(".Result_6d_4").html(obj.DrawNumber6D.charAt(3));
    $(".Result_6d_5").html(obj.DrawNumber6D.charAt(4));
    $(".Result_6d_6").html(obj.DrawNumber6D.charAt(5));
  };

  var updateResult = function updateResult(page) {
    var select_date = page.route.query.select_date;
    var d = new Date();

    if (select_date) {
      d = new Date(select_date);
    } else {
      if (d.getUTCHours + 8 <= 2000) d.setDate(d.getDate() - 1);
    }

    var n = d.getDate();
    var m = d.getMonth() + 1;
    var y = d.getFullYear();
    var h = d.getHours();
    var day = ("0" + n).slice(-2);
    var month = ("0" + m).slice(-2);
    var today = y + "-" + month + "-" + day;
    $(".select_date").val(today);
    console.log(today);
    update4D6D(localStorage.getItem("result"));
    $f7.preloader.show();
    $f7.request.get(window.atob("aHR0cHM6Ly9nZHBhcGkuc2RrMTY4LmNvbS9hcGkv") + 'result/' + y + '/' + m + '/' + n, {
      action: "none"
    }, function (data) {
      $f7.preloader.hide();
      console.log(data);

      if (data.replace(/[^a-zA-Z]/g, "") == "null") {
        d.setDate(date.getDate() - 1);
        n = d.getDate();
        m = d.getMonth() + 1;
        y = d.getFullYear();
      }

      var mTxt = "";
      if (m == 1) mTxt = "Jan";
      if (m == 2) mTxt = "Feb";
      if (m == 3) mTxt = "Mar";
      if (m == 4) mTxt = "Apr";
      if (m == 5) mTxt = "May";
      if (m == 6) mTxt = "Jun";
      if (m == 7) mTxt = "Jul";
      if (m == 8) mTxt = "Aug";
      if (m == 9) mTxt = "Sep";
      if (m == 10) mTxt = "Oct";
      if (m == 11) mTxt = "Nov";
      if (m == 12) mTxt = "Dec";
      $(".today-date").html(n + " " + mTxt + " " + y);
      $f7.request.get(window.atob("aHR0cHM6Ly9nZHBhcGkuc2RrMTY4LmNvbS9hcGkv") + 'result/' + y + '/' + m + '/' + n, {
        action: "none"
      }, function (data) {
        console.log(data);
        update4D6D(data);
        localStorage.setItem("result", data);
      });
    });
  };

  var alertNotReady = function alertNotReady() {
    localStorage.clear();
    $f7.dialog.alert("Page design not yet available");
  };

  $on('pageInit', function (e, page) {
    updateResult(page);
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="result">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner sliding">
        <div class="left">
          <a href="#" class="link back">
            <i class="icon icon-back"></i>
            <span class="if-not-md">
              <span class='en'>Back</span>
              <span class='cn'>返回</span>
              <span class='tl'>Fila</span>
            </span>
          </a>
        </div>
        <div class="title">Result</div>
      </div>
    </div>

    <!-- Scrollable page content-->
    <div class="page-content">

      <div class="block">
        <div class="list inline-labels no-hairlines-md">
          <ul>
            <li class="item-content item-input">
              <div class="item-media">
                <i class="icon demo-list-icon"></i>
              </div>
              <div class="item-inner">
                <div class="item-title item-label">


                    <span class='en'>Date</span>
                    <span class='cn'>日期</span>
                    <span class='tl'>Data</span>
                  
                </div>
                <div class="item-input-wrap">
                  <input type="date" class="select_date" placeholder="Please choose..." />
                </div>
              </div>
            </li>
          </ul>
        </div>


        <button class="button button-fill button-round" @click=${check}>
          <span class='en'>CHANGE DATE</span>
        </button>
      </div>      

      <!-- PRIZE RESULT -->
      <div class="card data-table" style="border-radius: 10px;">
        <table>
          <thead>
            <tr>
              <th colspan=2 class="label-cell" style="background-color: #C70039 ; color: rgb(255, 245, 191); font-size: 20px;">
                4D Result
              </th>
              <th class="text-align-right" style="background-color: #C70039 ;">
                <span class="today-date" style="font-size: 13px;font-weight: bold;color: rgb(255, 245, 191);">
                6 Feb 2021
              </span></th>
            </tr>
          </thead>
          <tbody class="text-align-center"> 
            <tr>
              <td class="label-cell tabular" width=33%><span style="font-size: 14px;">1</span><span style="font-size: 10px;">ST</span> <span class="en">Prize</span></td>
              <td class="label-cell tabular" width=33%><span style="font-size: 14px;">2</span><span style="font-size: 10px;">ND</span> <span class="en">Prize</span></td>
              <td class="label-cell tabular" width=33%><span style="font-size: 14px;">3</span><span style="font-size: 10px;">RD</span> <span class="en">Prize</span></td>
            </tr>
            <tr> 
              <td class="" width=33%><span style="color:#E7517C;" class="result_4d_1_alpha">x</span> <span style="font-size:18px" class="result_4d_1_num tabular">----</span></td>
              <td class="" width=33%><span style="color:#E7517C" class="result_4d_2_alpha">x</span> <span style="font-size:18px" class="result_4d_2_num tabular">----</span></td>
              <td class="" width=35%><span style="color:#E7517C" class="result_4d_3_alpha">x</span> <span style="font-size:18px" class="result_4d_3_num tabular">----</span></td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- SHOW FULL BEIGN -->
      <div class="show-full">
        <div class="card data-table" style="border-radius: 10px;">
          <table>
            <thead>
              <tr>
                <th colspan="3" class="label-cell text-align-center" style="background-color: #C70039; color: rgb(255, 245, 191); font-size: 14px; height: 20px;">
                  <span class="en">SPECIAL PRIZE</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="numeric-cell text-align-center"><span style="color:#E7517C;" class="result_4d_A_alpha">A</span> <span style="font-size:18px" class="result_4d_A_num tabular">----</span></td>
                <td class="numeric-cell text-align-center"><span style="color:#E7517C;" class="result_4d_B_alpha">B</span> <span style="font-size:18px" class="result_4d_B_num tabular">----</span></td>
                <td class="numeric-cell text-align-center"><span style="color:#E7517C;" class="result_4d_C_alpha">C</span> <span style="font-size:18px" class="result_4d_C_num tabular">----</span></td>
              </tr>
              <tr>
                <td class="numeric-cell text-align-center"><span style="color:#E7517C;" class="result_4d_D_alpha">D</span> <span style="font-size:18px" class="result_4d_D_num tabular">----</span></td>
                <td class="numeric-cell text-align-center"><span style="color:#E7517C;" class="result_4d_E_alpha">E</span> <span style="font-size:18px" class="result_4d_E_num tabular">----</span></td>
                <td class="numeric-cell text-align-center"><span style="color:#E7517C;" class="result_4d_F_alpha">F</span> <span style="font-size:18px" class="result_4d_F_num tabular">----</span></td>
              </tr>
              <tr>
                <td class="numeric-cell text-align-center"><span style="color:#E7517C;" class="result_4d_G_alpha">G</span> <span style="font-size:18px" class="result_4d_G_num tabular">----</span></td>
                <td class="numeric-cell text-align-center"><span style="color:#E7517C;" class="result_4d_H_alpha">H</span> <span style="font-size:18px" class="result_4d_H_num tabular">----</span></td>
                <td class="numeric-cell text-align-center"><span style="color:#E7517C;" class="result_4d_I_alpha">I</span> <span style="font-size:18px" class="result_4d_I_num tabular">----</span></td>
              </tr>
              <tr>
                <td class="numeric-cell text-align-center"><span style="color:#E7517C;" class="result_4d_J_alpha">J</span> <span style="font-size:18px" class="result_4d_J_num tabular">----</span></td>
                <td class="numeric-cell text-align-center"><span style="color:#E7517C;" class="result_4d_K_alpha">K</span> <span style="font-size:18px" class="result_4d_K_num tabular">----</span></td>
                <td class="numeric-cell text-align-center"><span style="color:#E7517C;" class="result_4d_L_alpha">L</span> <span style="font-size:18px" class="result_4d_L_num tabular">----</span></td>
              </tr>
              <tr>
                <td colspan=3 class="numeric-cell text-align-center"><span style="color:#E7517C;" class="result_4d_M_alpha">M</span> <span style="font-size:18px" class="result_4d_M_num tabular">----</span></td>
              </tr>
            </tbody>
          </table>  
        </div>
  
        <div class="card data-table" style="border-radius: 10px;">
          <table>
            <thead>
              <tr>
                <th colspan="3" class="label-cell text-align-center" style="background-color: #C70039; color: rgb(255, 245, 191); font-size: 14px; height: 20px;">
                  <span class='en'>CONSOLATION PRIZE</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="numeric-cell text-align-center"><span style="color:#E7517C;" class="result_4d_N_alpha">N</span> <span style="font-size:18px" class="result_4d_N_num tabular">----</span></td>
                <td class="numeric-cell text-align-center"><span style="color:#E7517C;" class="result_4d_O_alpha">O</span> <span style="font-size:18px" class="result_4d_O_num tabular">----</span></td>
                <td class="numeric-cell text-align-center"><span style="color:#E7517C;" class="result_4d_P_alpha">P</span> <span style="font-size:18px" class="result_4d_P_num tabular">----</span></td>
              </tr>
              <tr>
                <td class="numeric-cell text-align-center"><span style="color:#E7517C;" class="result_4d_Q_alpha">Q</span> <span style="font-size:18px" class="result_4d_Q_num tabular">----</span></td>
                <td class="numeric-cell text-align-center"><span style="color:#E7517C;" class="result_4d_R_alpha">R</span> <span style="font-size:18px" class="result_4d_R_num tabular">----</span></td>
                <td class="numeric-cell text-align-center"><span style="color:#E7517C;" class="result_4d_S_alpha">S</span> <span style="font-size:18px" class="result_4d_S_num tabular">----</span></td>
              </tr>
              <tr>
                <td class="numeric-cell text-align-center"><span style="color:#E7517C;" class="result_4d_T_alpha">T</span> <span style="font-size:18px" class="result_4d_T_num tabular">----</span></td>
                <td class="numeric-cell text-align-center"><span style="color:#E7517C;" class="result_4d_U_alpha">U</span> <span style="font-size:18px" class="result_4d_U_num tabular">----</span></td>
                <td class="numeric-cell text-align-center"><span style="color:#E7517C;" class="result_4d_V_alpha">V</span> <span style="font-size:18px" class="result_4d_V_num tabular">----</span></td>
              </tr>
              <tr>
                <td colspan=3 class="numeric-cell text-align-center"><span style="color:#E7517C;" class="result_4d_W_alpha">W</span> <span style="font-size:18px" class="result_4d_W_num tabular">----</span></td>
              </tr>
            </tbody>
          </table>  
        </div>


      <!-- GRAND PRIZE RESULT -->
      <div class="card" style="border-radius: 10px;">
        <div class="" style="background-color: #C70039;color: rgb(255, 245, 191); font-size: 20px;border-radius: 10px 10px 0 0;text-align: center;padding: 10px;">
          <B>6D</B>
        </div>
        <div class="card-content">
          <br/>
        <table width=100%>
          <tbody>
            <tr style="text-align: center;">
              <td style="color: rgb(255, 245, 191); font-size: 20px;"><b>1st</b></td><td > </td><td ><b><span class="Result_6d_1">x</span></b></td><td > </td><td ><b><span class="Result_6d_2">x</span></b></td><td > </td><td ><b><span class="Result_6d_3">x</span></b></td><td > </td><td ><b><span class="Result_6d_4">x</span></b></td><td > </td><td ><b><span class="Result_6d_5">x</span></b></td><td > </td><td ><b><span class="Result_6d_6">x</span></b></td><td > </td><td style="color: rgb(255, 245, 191); font-size: 20px;"><b>1st</b></td>
            </tr>
            <tr style="text-align: center;">
              <td >2nd</td><td class="Result_6d_1">x</td><td class="Result_6d_2">x</td><td class="Result_6d_3">x</td><td class="Result_6d_4">x</td><td class="Result_6d_5">x</td><td style="background-color:#000000"> </td><td style="font-size: 7px;">OR</td><td style="background-color:#000000"> </td><td class="Result_6d_2">x</td><td class="Result_6d_3">x</td><td class="Result_6d_4">x</td><td class="Result_6d_5">x</td><td class="Result_6d_6">x</td><td>2nd</td>
            </tr>
            <tr style="text-align: center;">
              <td >3rd</td><td class="Result_6d_1">x</td><td class="Result_6d_2">x</td><td class="Result_6d_3">x</td><td class="Result_6d_4">x</td><td style="background-color:#000000"> </td><td style="background-color:#000000"> </td><td  style="font-size: 7px;">            OR</td><td style="background-color:#000000"> </td><td style="background-color:#000000"> </td><td class="Result_6d_3">x</td><td class="Result_6d_4">x</td><td class="Result_6d_5">x</td><td class="Result_6d_6">x</td><td>3rd</td>
            </tr>
            <tr style="text-align: center;">
              <td >4th</td><td class="Result_6d_1">x</td><td class="Result_6d_2">x</td><td class="Result_6d_3">x</td><td style="background-color:#000000"> </td><td style="background-color:#000000"> </td><td style="background-color:#000000"> </td><td style="font-size: 7px;">                        OR</td><td style="background-color:#000000"> </td><td style="background-color:#000000"> </td><td style="background-color:#000000"> </td><td class="Result_6d_4">x</td><td class="Result_6d_5">x</td><td class="Result_6d_6">x</td><td>4th</td>
            </tr>
            <tr style="text-align: center;">
              <td >5th</td><td class="Result_6d_1">x</td><td class="Result_6d_2">x</td><td style="background-color:#000000"> </td><td style="background-color:#000000"> </td><td style="background-color:#000000"> </td><td style="background-color:#000000"> </td><td style="font-size: 7px;">                                    OR</td><td style="background-color:#000000"> </td><td style="background-color:#000000"> </td><td style="background-color:#000000"> </td><td style="background-color:#000000"> </td><td class="Result_6d_5">x</td><td class="Result_6d_6">x</td><td>5th</td>
            </tr>
          </tbody>
        </table>
        <br/>
        </div>
      </div>        
      </div>
      <!-- SHOW FULL END -->

    </div>
  </div>
`
    }
    ;
}

framework7Component.id = '16d626f072';
export default framework7Component;